export default {"src":"/_next/static/image/public/images/ic_insurance_guest.b2aec082edf98bd3e4abca45f531d72b.svg","height":150,"width":142};